import { reactive } from "vue";
import { fetcher } from "../api/fetcher";

export const featuresState = reactive({
  summaryShow: false,
})

type FeaturesDTO = {
  ai_summary: boolean;
}

export async function updateFeaturesState() {
  const res = await fetcher.get({
    path: "/features",
  }) as FeaturesDTO
  featuresState.summaryShow = res.ai_summary
}
